import { ApiUrl } from '../app/Config';

define(['backbone'], function(Backbone) {
  return Backbone.Model.extend({
    urlRoot: ApiUrl + 'Providers',
    idAttribute: 'FillProviderID',
  });
});
